import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CardModule } from 'primeng/card';

@Component({
  selector: 'app-base-card',
  imports: [CardModule, CommonModule],
  templateUrl: './base-card.html',
  styleUrls: ['./base-card.scss']
})
export class BaseCard {}
